import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SM_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { setIsModalHide } from '@yme/modals/actions';
import { getModalData } from '@yme/modals/selectors';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export const InfoModal = () => {
    const isRightToLeft = useSelector(getRTL);
    const { title, description } = useSelector(getModalData);
    const dispatch = useDispatch();
    const handleHideModal = useCallback(() => {
        dispatch(setIsModalHide());
    }, [dispatch]);
    return (React.createElement(StaticModalWindow, { onHide: handleHideModal, minHeight: "auto", staticModalSize: SM_MODAL, title: title, isRightToLeft: isRightToLeft },
        React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description)));
};
